import { useChatStore } from "@metalmind-ab/mmagent-chat-ui";

export const STREAM_INTERRUPTED_MARKER =
  "\n\n_[Connection interrupted — response may be incomplete. Send your prompt again to retry.]_";

const INTERRUPTION_NOTICE =
  "Connection interrupted — response may be incomplete.";
const RETRY_NOTICE = `${INTERRUPTION_NOTICE} Send your prompt again to retry.`;

type InterruptibleMessage = {
  id: string | number;
  content?: unknown;
};

type InterruptibleChatState = {
  messages: InterruptibleMessage[];
  appendToMessage: (messageId: string | number, content: string) => void;
};

/** Append the interruption notice at most once to a streamed assistant turn. */
export function appendStreamInterruptedMarkerOnce(
  messageId: string | number,
): void {
  const state = useChatStore.getState() as unknown as InterruptibleChatState;
  const message = state.messages.find((item) => item.id === messageId);
  if (!message) return;

  if (
    typeof message.content === "string" &&
    hasInterruptionNotice(message.content)
  ) {
    return;
  }

  state.appendToMessage(messageId, STREAM_INTERRUPTED_MARKER);
}

function hasInterruptionNotice(content: string): boolean {
  return content.split(/\r?\n/).some((line) => {
    let notice = line.trim();
    if (!notice || notice.startsWith(">")) return false;

    if (notice.startsWith("_") && notice.endsWith("_")) {
      notice = notice.slice(1, -1).trim();
    }
    if (notice.startsWith("[") && notice.endsWith("]")) {
      notice = notice.slice(1, -1).trim();
    }

    return notice === INTERRUPTION_NOTICE || notice === RETRY_NOTICE;
  });
}
